import { FC } from "react";
import cn from "classnames";
import { Card } from "capitalrx-components-2.0";

import { FAQCardProps } from "../FAQSection.props";
import styles from "../FAQSection.module.scss";

const FAQCard: FC<FAQCardProps> = ({ title, setActiveFAQItem, isActive, id, testId }: FAQCardProps) => {
  const faqCardStyle = cn(styles["FAQCard"], { [styles["Active"]]: isActive });
  const activeDiamond = cn({ [styles["ActiveDiamond"]]: isActive });

  return (
    <div className={styles.SingleFAQCardWrapper} data-testid={testId}>
      <Card className={faqCardStyle}>
        <button className={styles.FAQCardButton} onClick={() => setActiveFAQItem(title)} aria-describedby={id}>
          {title}
        </button>
      </Card>
      <div className={activeDiamond}></div>
    </div>
  );
};

export default FAQCard;
